import { Link } from "react-router-dom";
import { WorkspaceHeader } from "../components/layout/WorkspaceHeader";
import { ApiTokenManager } from "../components/account/ApiTokenManager";
import { useActiveBrand } from "../hooks/useActiveBrand";

export function ApiTokensPage() {
  const { activeBrand } = useActiveBrand();

  return (
    <div className="mx-auto max-w-5xl space-y-6 py-4">
      <WorkspaceHeader
        eyebrow="Account"
        title="API tokens"
        description="Create and revoke HelloConvo CLI tokens for external consumers, agents, and automations."
        breadcrumbs={[
          { label: "Workspace", href: "/home" },
          { label: "Account settings", href: "/settings" },
          { label: "API tokens" },
        ]}
        metadata={(
          <>
            <span className="rounded-full bg-white px-2.5 py-1 ring-1 ring-slate-200">
              Account-scoped credentials
            </span>
            <span className="rounded-full bg-white px-2.5 py-1 ring-1 ring-slate-200">
              One-time secret reveal
            </span>
          </>
        )}
        actions={(
          <Link
            to="/settings"
            className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Back to account settings
          </Link>
        )}
      />

      <ApiTokenManager brandName={activeBrand?.name ?? null} />
    </div>
  );
}
